import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Flex, Input, Select, Typography } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addAbonementClub, getAbonementTypes, getAbonementsListClubs } from 'src/store/Slices/AbonementsSlice'
import { openNotification } from 'src/components/helpers/notification';

const AddNewAbonementCost = ({ visible, setVisible, abonementInfo, payload }) => {

    // HELPERS
    const dispatch = useDispatch()
    const optionsFreeze = [
        { label: 'Да', value: 1 },
        { label: 'Нет', value: 0 }
    ]

    // STATE
    const [club, setClub] = useState()
    const [isFreeze, setIsFreeze] = useState()
    const [price, setPrice] = useState()
    const [months, setMonths] = useState()
    const [daysOfFreeze, setDaysOfFreeze] = useState()
    const [name, setName] = useState()
    const [fastbuyButtonName, setFastbuyButtonName] = useState()

    const abonementClubs = useSelector(state => state.AbonementsSlice.abonementClubs)


    useEffect(() => {
        dispatch(getAbonementTypes())
    }, [])

    const onClickAddAbonement = () => {
        dispatch(addAbonementClub({
            abonementId: abonementInfo.id,
            clubId: club,
            isFrost: !!isFreeze,
            price: price,
            monthCount: months,
            frostDays: daysOfFreeze,
            packetName: name,
            fastbuyButtonName: fastbuyButtonName,
            isPrimary: false
        })).then(() => {
            dispatch(getAbonementsListClubs({ AbonementId: abonementInfo.id, ...payload })).then(() => {
                setVisible(false)
            })
        })
    }

    return (
        <CModal
            alignment="center"
            visible={visible}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible(false) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Добавить стоимость пакета'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                options={abonementClubs?.data?.value}
                                placeholder={'Выбрать'}
                                onChange={(value) => { setClub(value) }}
                                value={club}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Разрешена заморозка</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                options={optionsFreeze}
                                placeholder={'Выбрать'}
                                onChange={(value) => { setIsFreeze(value) }}
                                value={isFreeze}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Цена</Typography.Title>
                            <Input
                                defaultValue=""
                                value={price}
                                type='number'
                                onChange={(e) => setPrice(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Кол-во месяцев</Typography.Title>
                            <Input
                                defaultValue=""
                                value={months}
                                type='number'
                                onChange={(e) => setMonths(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Дней заморозки</Typography.Title>
                            <Input
                                defaultValue=""
                                value={daysOfFreeze}
                                type='number'
                                onChange={(e) => setDaysOfFreeze(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Имя пакета</Typography.Title>
                            <Input
                                defaultValue=""
                                value={name}
                                onChange={(e) => setName(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Текст для кнопки покупки</Typography.Title>
                            <Input
                                defaultValue=""
                                value={fastbuyButtonName}
                                onChange={(e) => setFastbuyButtonName(e.currentTarget.value)}
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible(false) }}
                    style={{ color: '#fff' }}
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickAddAbonement} style={{ color: '#fff' }}>
                    Добавить
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddNewAbonementCost